import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgTicket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#3A3247",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 13h4v-2h-4zm6 5h-.413c-.603-1.437-1.833-2.424-3.587-2.424S9.016 16.563 8.413 18H8V6h.413C9.016 7.437 10.246 8.424 12 8.424S14.984 7.437 15.587 6H16zM14 4s0 2.424-2 2.424S10 4 10 4H6v16h4s0-2.424 2-2.424S14 20 14 20h4V4z",
  clipRule: "evenodd"
})));

export { SvgTicket as ReactComponent };
//# sourceMappingURL=Ticket.svg.js.map
